import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useContext,
    useState,
} from "react"
import DataList from "../DataList"
import FullNameInput from "../FullNameInput"

import ApplicantDataFormContext from "../../Contexts/ApplicantDataFormContext"

const attributes = [
    {
        type: "full_name",
        key: "full_name",
    },
]

const FullNameAndAkaInput = forwardRef(({ title, data, readOnly }, ref) => {

    const fullNameRef = useRef()
    const akaListRef = useRef()

    const fieldData = data || {}

    const applicantDataForm = useContext(ApplicantDataFormContext)

    const [showAkaList, setShowAkaList] = useState(
        Array.isArray(fieldData.akaList) && fieldData.akaList.length > 0
    );

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const fullNameResult = fullNameRef.current.validateAndGetData()
            let akaListResult = { isValid: true, value: [] };

            if (showAkaList && akaListRef.current) {
                akaListResult = akaListRef.current.validateAndGetData();
            }

            const akaListValue = akaListResult.value.map(aka => aka.full_name)

            if (applicantDataForm?.current) {
                applicantDataForm.current["identity_information.full_name.aka_list"] = akaListValue
            }

            return {
                isValid: fullNameResult.isValid && akaListResult.isValid,
                value: {
                    fullName: fullNameResult.value,
                    akaList: akaListResult.value,
                }
            }
        },
    }))

    return (
        <div className="my-4">

            <label className="block text-base font-medium text-gray-700 mb-4">{title}</label>

            <FullNameInput ref={fullNameRef} data={fieldData.fullName} readOnly={readOnly} />

            <div className="flex items-center mb-2">
                <input
                    type="checkbox"
                    id="aka-checkbox"
                    className="mr-2"
                    checked={showAkaList}
                    disabled={readOnly}
                    onChange={e => setShowAkaList(e.target.checked)}
                />
                <label htmlFor="aka-checkbox" className="text-sm text-gray-700">
                    Have you used any other names or aliases?
                </label>
            </div>

            {showAkaList && (
                <DataList
                    ref={akaListRef}
                    attributes={attributes}
                    data={fieldData.akaList}
                    title={"Name"}
                    addButtonText={"Add a Different Name"}
                    readOnly={readOnly}
                />
            )}


        </div>
    )
})

export default FullNameAndAkaInput
